import { render, staticRenderFns } from "./TeachingWorkSubmitModal.vue?vue&type=template&id=0e9f0d8f"
import script from "./TeachingWorkSubmitModal.vue?vue&type=script&lang=js"
export * from "./TeachingWorkSubmitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports